<template>
    <div class="clearfix company-form-container rounded mt-4 pb-3 mx-auto pl-3 pr-3">

        <div class="clearfix row py-2 mb-2 border-bottom">
            <div class="col-sm-12 company-form-box-title text_color">Representatives</div>
        </div>

        <div class="row justify-content-center mt-3">

            <div class="col-sm-12 px-0">

                <b-form class="p-2" @submit.stop.prevent="onSubmit">
                    <div class="clearfix">
                        <div class="px-2">
                            <b-form-group  id="employee-group" label="Employee" class="required-field" label-for="employee">
                                <b-input-group>
                                    <b-form-input id="employee" name="employee" v-model="fdata.employeeRep" class="radius-8" v-validate="{ required: true, regex: /^[A-Za-z\s]+$/, min: 3, max:40 }" :state="validateState('employee')" aria-describedby="employee-feedback" data-vv-as="Employee"></b-form-input>
                                    <b-form-invalid-feedback id="employee-feedback">{{ veeErrors.first('employee') }}</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group  id="name-group" label="Company" class="required-field" label-for="company">
                                <b-input-group>
                                    <b-form-input id="company" name="company" v-model="fdata.companyRep" class="radius-8" v-validate="{ required: true, regex: /^[A-Za-z\s]+$/, min: 3 }" :state="validateState('company')" aria-describedby="company-feedback" data-vv-as="Company"></b-form-input>
                                    <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('company') }}</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                            <div class="text-center mt-5">
                                <b-button type="submit" class="px-5" variant="primary">Save</b-button>
                            </div>
                        </div>
                    </div>
                </b-form>
            </div>

        </div>

    </div>
</template>


<script>
export default{

    mounted() {
        this.permission = this.$acl['Role/details'];
    },

    props: ['ce_flg' , 'check_ce' , 'flg', 'pf'],
    data(){

        return {
            fdata: {
                companyRep: '',
                employeeRep: '',
            },
            saved_name : '',
            pgurl:this.$api_url,
            file: null,
            search:'',
            length: 20,
            temp_length:20,
            people:0,
            dangermsg:false,
            addtype : false,
            permission : 0,
        }
    },
    methods:{
        getRepresentativeData: function() {
            if(!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url+'/bot/role/representatives',{
              params:{
                pf:this.pf
              }
            }).then(function(response){
                this.fdata.employeeRep = response.data[0]
                this.fdata.companyRep = response.data[1]

            }.bind(this)).catch(error => this.serverError(error));
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = {name:null, status:null, id:null};
            this.file = null;
            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        onSubmit(e) {
            if(!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;
            this.$validator.validateAll().then(result => {
                if (!result) return;
                e.preventDefault();
                let currentObj = this;
                let formData = new FormData();

                for(const [key, value] of Object.entries(this.fdata)){
                    formData.append(key, value);
                }

                axios.post(this.$api_url+'/bot/role/representative/save?pf='+this.pf, formData)
                    .then( response => {
                        this.successmsg = 'Saved!';
                        this.$bvToast.toast(response.data.message, {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                        this.$bvModal.hide('bv-modal-representative');

                    }).catch( error => {
                    currentObj.errormsg = error.response.data.errors;
                    this.serverError(error)
                });
            });
        },

    },
    created: function(){
        this.getRepresentativeData();
    },
}
</script>
